import { first, result } from "underscore";
import { DataStore } from "shared_critical/store";
import { trackSave } from "shared_critical/tracking/shared/saves";

var memId = DataStore.getData('memberId');

var parseCookie = function() {
  var pairs = $.cookie('REMEMBER_ME').slice(1).split('&');

  var result = {};
  pairs.forEach(function(pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });

  return result;
};

// create the warning model when over limit listings are being saved
var createSaveLimitWarning = function (){
  var warningContent = JST["templates/saving_over_limit_warning"];
  // If the warning modal already exists, remove the old one and add a new one.
  // The auto fadeout will be reset.
  var htmlBody = $('body');
  var warningModal = $("#save-listing-error-alert");
  if (htmlBody.find(warningModal).length !== 0){
    warningModal.remove();
  }
  htmlBody.append(warningContent);
  warningModal = $("#save-listing-error-alert");
  // Remove the modal when click on the hide button (the x on the upper-right)
  $('#save-listing-error-alert-dismiss').click(function(){
    warningModal.remove();
  });
  // Remove the modal automatically after 10 seconds
  warningModal.fadeTo(10000, 100).fadeOut('slow',function(){
    warningModal.remove();
  });
};

var saveListing = function (e, options) {
  $.ajax({
    url: "/favorite_listings",
    method: "POST",
    data: getSaveListingData(options.listing),
    beforeSend: function () {
      $(e.currentTarget).attr('disabled', 'disabled');
    },
    success: function (data) {
      // Currently from the error object, the message field is the only place
      // telling us it is an overlimit error.
      var errors = data.meta.errors;
      var overLimitMsg = "maximum 250 saved resources are allowed per member";
      for(var i = 0; i < errors.length; i++){
        if(errors[i].message === overLimitMsg){
          createSaveLimitWarning();
          break;
        }
      }
      if (isResponseSuccess(data)) {
        if (typeof options.callBack === 'function') {
          var callbackData;
          if (options.omtag) {
            const listingId = options.listing && options.listing.listing_id;
            callbackData = Object.assign({}, data, {omtag: options.omtag, listingId});
            MOVE_DATA.subResId = (data.resources || {}).id;
          } else {
            callbackData = data;
          }
          options.callBack(callbackData);
        }
      }
      else {
        if (typeof options.onErrorCallBack === 'function') {
          options.onErrorCallBack(data);
        }
      }
      $(e.currentTarget).removeAttr('disabled');
      $('body').trigger('SavedListing');

      var userId = MOVE.Common.parseCookie()["regID"];

      if (options.listing.save_aware === false && (!$.cookie("saveAware") || $.cookie("saveAware") !== userId)) {
        if (options.requireReload) {
          $.cookie('showSaveAwareOnReload', JSON.stringify({"target": $(e.target).closest('.js-save-alert-wrapper')[0].id, "userId": userId}));
        } else {
          showSaveAwarePopUp(e.target, userId);
        }
      }

      // LGWEB-718
      if (MOVE_DATA.ab_share_srp === 'V1' || MOVE_DATA.ab_share_srp === 'V2' ) {
        $('#shareEmailThankYou.modal').on('hide.bs.modal', function() {
          if (!$('body').hasClass('qv-open')) {
            $('#shareEmailThankYou').remove();
            $('.modal-backdrop.fade.in').remove();
            $('.full-screen-qv').removeClass('modal-open');
          }
        })
      }
    },
    error: function(){
      if (options.requireReload) {
        location.reload();
      }
    }
  });
};

var showSaveAwarePopUp = function(target, userId) {
  var $saveNotification = $('#save-alert-notification'),
  $alertWrapper = $(target).closest('.js-save-alert-wrapper');
  $alertWrapper.append($saveNotification.fadeIn("slow"));
  $('.js-save-trigger').on('click', function() {
    $alertWrapper.append($saveNotification.fadeOut("slow"));
  })
  $.cookie("saveAware", userId, {path: '/'});
};

var showSaveAwarePopUpOnRefresh = function() {
  if ($.cookie('showSaveAwareOnReload')) {
    var options = $.parseJSON(($.cookie('showSaveAwareOnReload'))),
        target = '#' + options.target,
        userId = options.userId;
    showSaveAwarePopUp(target, userId);
    $.removeCookie('showSaveAwareOnReload');
  }
}

var hideListing = function (e, options) {
  $.ajax({
    url: "/hide_listings",
    method: "POST",
    data: getSuppressListingData(options.listing),
    beforeSend: function () {
      $(e.currentTarget).attr('disabled', 'disabled');
    },
    success: function (data) {
      if (isResponseSuccess(data)) {
        if (typeof options.callBack === 'function') {
          options.callBack(data);
        }
      }
    },
    error: function(){
      if (options.requireReload) {
        location.reload();
      }
    },
    complete: function() {
      $(e.currentTarget).removeAttr("disabled");
    }
  });
};

var unhideListing = function (e, options) {
  e.stopPropagation();
  $.ajax({
    url: "/hide_listings",
    method: "DELETE",
    data: getSuppressListingData(options.listing),
    beforeSend: function () {
      $(e.currentTarget).attr('disabled', 'disabled');
    },
    success: function (data) {
      if (isResponseSuccess(data)) {
        options.callBack(data);
      }
    },
    complete: function() {
      $(e.currentTarget).removeAttr("disabled");
    }
  });
};

var getSaveListingData = function (listing) {
  var save_data = {
    memberId: memId || parseCookie().regID,
    resType: "property",
    resId: listing.property_id,
    subResType: listing.status,
    subResId: listing.listing_id || listing.listingid,
    note: listing.note
  };
  return save_data;
};

var getSuppressListingData = function (listing) {
  var propertyData = {
    user_id: memId || parseCookie().regID,
    prop_type: listing.status,
    property_id:listing.property_id
  }
  return propertyData;
};

var getDeleteListingData = function (id) {
  var delete_data =
  {
    id: id
  };
  return delete_data;
};

var deleteListing = function (e, options) {
  e.stopPropagation();
  $.ajax({
    url: "/favorite_listings",
    method: "DELETE",
    data: getDeleteListingData(options.id),
    beforeSend: function () {
      $(e.currentTarget).attr('disabled', 'disabled');
    },
    success: function (data) {
      // Adding logic for after success
      if (isResponseSuccess(data)) {
        MOVE_DATA.subResId = null;
        options.callBack(data);
      }
      // Trigger hide if the porperty is being unsaved because of "Hide CTA" click
      if($(e.currentTarget).data('triggerHide') === true) {
        $(e.currentTarget).data('triggerHide', null);
        $('body').trigger('hideOnSavedProperty');
      }
      $(e.currentTarget).removeAttr("disabled");
      $('body').trigger('DeletedListing');
    }
  });
};

var isResponseSuccess = function (data) {
  let isSuccess = false;
  if (data !== undefined && data.meta !== undefined && data.meta.success !== undefined) {
    isSuccess = data.meta.success;
  }
  return isSuccess;
};

var readMore = function (target, collapsedHeight, linkPrefix, callback, lessAnimation, scrollTopOffset) {
  if (linkPrefix) {
    linkPrefix = linkPrefix + ' ';
  } else {
    linkPrefix = '';
  }

  $(target).readmore({
    speed: 100,
    collapsedHeight: collapsedHeight,
    lessAnimation: lessAnimation,
    moreLink: '<a href="#">' + linkPrefix + 'More' + '<i class="ra ra-angle-down"></i></a>',
    lessLink: '<a href="#">'+ linkPrefix + 'Less' +'<i class="ra ra-angle-up"></i></a>',
    afterToggle: function (trigger, element, expanded) {
      // "Less" link was clicked
      var scrollTop = $(element).offset().top - (scrollTopOffset ? scrollTopOffset : 0);
      if (!expanded && this.lessAnimation) {
        $('html, body').animate({scrollTop: scrollTop}, {duration: 100});
      }
      if (callback) {
        callback(expanded);
      }
    }
  });
};

var showStickyBar = function(target,scrollPoint) {
  if (target.length > 0) {
    $(window).bind('scroll', function () {
      if ($(window).scrollTop() > scrollPoint) {
        $(target).addClass('scrolled');
        $(window).trigger(target); // AB CORE-13176 sticky lead form
      } else {
        $(target).removeClass('scrolled');
      }
    });
  }
};

var stickyAd = function (target, options) {
  if (target.length > 0 && MOVE.DOMHelper.getUrlParams().sticky !== 'no') {
    target.scrollChaser(options);
  }
};

var inPageNavigation = function (target, anchoroffset, scrollspeed) {
  if (target.length > 0) {
    $(target).find("a[href*='#']:not([href='#'])").click(function(event) {
      var checkPath = location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '');
      if (checkPath || location.hostname === this.hostname) {
        var target = MOVE.Helper.getPageNavTarget($(this.hash));
        if (target.length) {
          var scrollToPosition = $(target).offset().top - anchoroffset;
          $('html,body').animate({ scrollTop: scrollToPosition }, scrollspeed);
          //Changing from return false as this is preventing the edw events getting fired.
          event.preventDefault();
        }
      }
    });
  }
};

var openModalMovingLeadOmniture = function () {
  _satellite.track("moving-quote:modal");
};

var successMovingLeadOmniture = function () {
  _satellite.track("leads:moving-quote");
};

var trackVideoOmniture = function(video) {
  if (window.MOVE_DATA && window.MOVE_DATA.adobeDTM) {
    window.MOVE_DATA.adobeDTM.videoId = video.id;
  }

  if (_satellite && _satellite.track) {
    _satellite.track('videoReady');
  }
};

var trackVideoFirstFrame = function(player) {
  player.on('firstFrame', function(f) {
    if (window.MOVE_DATA && window.MOVE_DATA.adobeDTM) {
      window.MOVE_DATA.adobeDTM.videoLoadTime = f.loadTime;
    }
  });
};

var trackSaveSuccess = function(omtag, listingId) {
  MOVE_DATA.adobeDTM.saveItem = 'listing';
  MOVE_DATA.adobeDTM.saveItemPlacement = omtag;
  trackSave('listing', omtag, listingId);
};

var savePropertyCards = function(){

  $(document)
    .on('click', '.hp-save', addToSaveButton)
    .on('click', '.hp-unsave', removeFromSavedButton)

  // All saving buttons on LDP use login modal instead of redirect
  // Parameters required for saving are stored in the parent elements with .js-tracking class
    .on('click','.hp-save-not-logged-in', {is_listings: true}, function(e) {
      var $el = $(this);
      var omtag = $($el).closest('[data-omtag]').data('omtag');
      var listingId = $($el).closest('.js-tracking').data('listingid') || $($el).closest('.js-tracking').data('listingId');
      var raasCallBack = function(){
        trackSaveSuccess(omtag, listingId);
        location.reload();
      };
      var opts = {
        source: "save_home",
        triggerLocation: "hp:card:save-listing"
      };
      MOVE.ModalHelper.raasSwap(function(){
        var parent = $el.closest('.js-tracking');
        MOVE.Common.saveListing(e, {listing: getPropertyInfo(parent), callBack: raasCallBack});
        //saveListingLoginTracking();
        e.preventDefault();
      }, opts);

      return false;
    });
};

var saveListingLoginTracking = function(){
  MOVE_DATA.adobeDTM.raas = MOVE_DATA.adobeDTM.raas || {};
  MOVE_DATA.adobeDTM.raas.placement = 'saved-listing';
};

var loginTracking = function(el){
  var omtag = el.children().data('omtag-login') || el.data('omtag-login');
  MOVE_DATA.adobeDTM.raas = MOVE_DATA.adobeDTM.raas || {};
  MOVE_DATA.adobeDTM.raas.placement = omtag;
};

var addToSaveButton = function (e) {
  e.stopPropagation();
  var that    = this;
  var parent  = $(this).parents('.js-tracking').first();
  var omtag = $(that).closest('[data-omtag]').data('omtag');
  // Home page uses SRP cards now and that has data in "listing-id" node where as LDP has it in "listingid"
  var dataTag = parent.data('listingid') ? 'data-listingid' : 'data-listing-id';

  var callBack = function (data) {
    var $tracker  = $(that).closest('.js-tracking'),
        listingId = $tracker.data('listingid') || $tracker.data('listingId');

    $('div['+ dataTag + '="' + listingId + '"]')
      .find('.hp-save').hide()
      .removeAttr('disabled').end()
      .find('.hp-unsave')
      .attr('data-res-id', data.resources.id)
      .show();

    //Storing Saved MyProperties for loggedin users
    window.GNAV.MYACCOUNT.getSavedResponse("my_properties");
    trackSaveSuccess(omtag, listingId);
    // For homes near street browse module, since the "Save" is on map card, we need to maintain a
    // local list to keep track of saved / unsaved listings. This function triggers the method which updates the local variable
    if($tracker.hasClass('js-hns-save')) {
      $('body').trigger('UpdateHomesNearStreetSave',[listingId, data.resources.id]);
    }
    if ($tracker.hasClass('browse-module-card')) {
      setSavedListings(listingId, data.resources.id);
    }
  };

  MOVE.Common.saveListing(e, { listing: getPropertyInfo(parent), callBack: callBack });
};

var getPropertyInfo = function(divElement) {
  var parent = $(divElement);
  return {
    property_id: parent.data('propertyid') || parent.data('propertyId'),
    status: parent.data('status'),
    listing_id: parent.data('listingid') || parent.data('listingId')
  };
}

var removeFromSavedButton = function (e) {
  e.stopPropagation();
  var that = this;
  var callBack = function () {
    var $tracker  = $(that).closest('.js-tracking'),
        listingId = $tracker.data('listingid') || $tracker.data('listingId'),
        // Home page uses SRP cards now and that has data in "listing-id" node where as LDP has it in "listingid"
        dataTag   = $tracker.data('listingid') ? 'data-listingid' : 'data-listing-id';

    $('div['+ dataTag + '="' + listingId + '"]')
      .find('.hp-unsave')
      .attr('data-res-id', null).hide().removeAttr('disabled')
      .end()
      .find('.hp-save')
      .show();

    //Storing Saved MyProperties for loggedin users
    window.GNAV.MYACCOUNT.getSavedResponse("my_properties");
    // For homes near street browse module, since the "Save" is on map card, we need to maintain a
    // local list to keep track of saved / unsaved listings. This function triggers the method which updates the local variable
    if($tracker.hasClass('js-hns-save')) {
      $('body').trigger('UpdateHomesNearStreetSave', [listingId, null]);
    }
    if ($tracker.hasClass('browse-module-card')) {
      deleteSavedListings(listingId);
    }
  };

  MOVE.Common.deleteListing(e, {id: $(that).data("res-id"), callBack: callBack});
  e.stopPropagation();
  return false;
};

var getCriteriaFromValue = function(value){
  return MOVE.CONSTANTS.PROP_TYPE_VALUE_TO_CRIT_MAPPING[value];
};

var getValueFromCriteria = function(criteria){
  return MOVE.CONSTANTS.PROP_TYPE_CRIT_TO_VALUE_MAPPING[criteria];
};

var initializeMoreFitlerCollapse = function(){
  $('#facet-morefilters a[data-toggle="collapse"]').on('click', function (event) {
    var $currentCollapse = $(this);
    event.preventDefault();
    event.stopPropagation();
    if ($currentCollapse.hasClass('collapsed')) {
      $($currentCollapse.attr('data-target')).collapse('show');
    } else {
      $($currentCollapse.attr('data-target')).collapse('hide');
    }
  });
};

var cacheInputs = function($name, $email, $phone) {
  if (MOVE.LocalStorage.isAvailable) {
    var cache = _.propertyOf(getCachedInputsData());
    var data = {
      'fullName': _.result($name, 'val', cache('fullName')),
      'email':    _.result($email, 'val', cache('email')),
      'phone':    _.result($phone, 'val', cache('phone'))
    };

    localStorage.setItem(
      MOVE.CONSTANTS.CACHED_USER_INPUT_STOREAGE_NAME, JSON.stringify(data)
    );
  }
};

var getCachedInputs = function($form){
  if (MOVE.LocalStorage.isAvailable) {
    var data = getCachedInputsData();
    if (data){
      $form.find('.fullName').val(data.fullName);
      $form.find('.email').val(data.email);
      $form.find('.phone').val(data.phone);
    }
  }
};

var getCachedInputsData = function() {
  if (MOVE.LocalStorage.isAvailable) {
    var data = localStorage.getItem(MOVE.CONSTANTS.CACHED_USER_INPUT_STOREAGE_NAME);
    if (!data && $.cookie('REMEMBER_ME') && MOVE.DataStore.getData(MOVE.CONSTANTS.CACHED_USER_PROFILE_LEAD_INPUTS)) {
      data = MOVE.DataStore.getData(MOVE.CONSTANTS.CACHED_USER_PROFILE_LEAD_INPUTS);
    }
    if (data) {
      return JSON.parse(data);
    }
  }
};

var addNewRelicLog = function(name, payload) {
  if (typeof newrelic === 'object') {
    window.newrelic.addPageAction(
      name, payload
    );
  }
};

var getFacetHomeFeatureValue = function(key){
  return MOVE.SRP.CONSTANTS.FACET_HOME_FEATURES_MAPPING[key];
};

export const leadErrorMsg = function(data) {
  const withDefault = (obj, field, _default = {}) => result(obj, field, _default);

  var meta      = withDefault(data, 'meta'),
      errors    = withDefault(meta, 'errors', []),
      error     = first(errors) ||  {},
      lead      = withDefault(meta.params, 'lead'),
      form      = withDefault(lead, 'form'),
      client    = withDefault(lead, 'client'),
      user      = withDefault(lead, 'user'),
      lead_data = withDefault(lead, 'lead_data'),
      resource  = withDefault(lead, 'resource');

  return {
    api_url:            error.api_url,
    fesl_endpoint:      meta.fesl_endpoint,
    error_code:         error.code,
    error_msg:          error.message,
    form_name:          form.name,
    form_variant:       form.variant,
    lead_type:          lead.type,
    lead_email:         lead_data.email,
    lead_fname:         lead_data.first_name,
    lead_lname:         lead_data.last_name,
    lead_msg:           result(lead_data.message, 'body'),
    lead_phone:         lead_data.phone,
    resource_id:        resource.resource_id,
    resource_type:      resource.resource_type,
    sub_resource_id:    resource.sub_resource_id,
    sub_resource_type:  resource.sub_resource_type,
    client_ip_address:  client.ip_address,
    user_session_id:    user.session_id,
    user_visitor_id:    user.visitor_id,
    request_guid:       result(error.request_body, 'request_guid')
  };
};

var endsWith = function(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
};

var isValidLatLng = function (lon, lat) {
  return (!isNaN(lon) && !isNaN(lat) && lon !== 0 && lat !== 0 &&
          lon > -180 && lon < 180 && lat > -90 && lat < 90);
};

var getSavedListings = function() {
  var savedListings = window.localStorage.getItem('browseModulesSavedListings');
  return savedListings ? savedListings.split(',') : [];
};

var setSavedListings = function(listingId, resourceId) {
  if (MOVE.LocalStorage.isAvailable) {
    var savedListings  = getSavedListings(),
        savedListingId = listingId + ':' + resourceId;

    if (!_.contains(savedListings, savedListingId)) {
      window.localStorage.setItem(
        'browseModulesSavedListings',
        savedListings.concat(savedListingId).join(',')
      );
    }
  }
};

var deleteSavedListings = function(listingId) {
  if (MOVE.LocalStorage.isAvailable) {
    var savedListings = _.filter(
      getSavedListings(), function(listing) {
        var lid = listing.split(':')[0];
        return parseInt(lid) !== parseInt(listingId);
      });

    if (savedListings.length) {
      window.localStorage.setItem('browseModulesSavedListings', savedListings);
    } else {
      window.localStorage.removeItem('browseModulesSavedListings');
    }
  }
};

var getSavedResourceId = function(property, savedListings) {
  if(property.status !== 'for_sale') {
    return;
  }
  var savedListing = _.find(savedListings, function(listing) {
    return parseInt(listing.sub_resource_id) === parseInt(property.listing_id);
  });
  return (savedListing || {}).id;
}

MOVE.Common = {
  saveListing: saveListing,
  deleteListing: deleteListing,
  readMore: readMore,
  stickyAd: stickyAd,
  showStickyBar: showStickyBar,
  inPageNavigation: inPageNavigation,
  openModalMovingLeadOmniture: openModalMovingLeadOmniture,
  successMovingLeadOmniture: successMovingLeadOmniture,
  trackVideoOmniture: trackVideoOmniture,
  trackVideoFirstFrame: trackVideoFirstFrame,
  createSaveLimitWarning: createSaveLimitWarning,
  parseCookie: parseCookie,
  addToSaveButton: addToSaveButton,
  removeFromSavedButton: removeFromSavedButton,
  savePropertyCards: savePropertyCards,
  saveListingLoginTracking: saveListingLoginTracking,
  loginTracking: loginTracking,
  getValueFromCriteria: getValueFromCriteria,
  getCriteriaFromValue: getCriteriaFromValue,
  getFacetHomeFeatureValue: getFacetHomeFeatureValue,
  initializeMoreFitlerCollapse: initializeMoreFitlerCollapse,
  cacheInputs: cacheInputs,
  getCachedInputs: getCachedInputs,
  getCachedInputsData: getCachedInputsData,
  addNewRelicLog: addNewRelicLog,
  leadErrorMsg: leadErrorMsg,
  endsWith: endsWith,
  isValidLatLng: isValidLatLng,
  setSavedListings: setSavedListings,
  getSavedListings: getSavedListings,
  deleteSavedListings: deleteSavedListings,
  hideListing: hideListing,
  unhideListing: unhideListing,
  showSaveAwarePopUpOnRefresh: showSaveAwarePopUpOnRefresh,
  getSavedResourceId: getSavedResourceId,
  trackSaveSuccess: trackSaveSuccess
};



// WEBPACK FOOTER //
// ./shared_non_critical/common.js